<template lang="">
  <div>
    <!-- {{ offerByID }} -->
    <b-row class="match-height">
      <b-col
        cols="12"
        xl="12"
        lg="12"
        md="12"
      >
        <OffersAction :offer-entry="offerByID" />
      </b-col>
    </b-row>
    <b-row class="match-height">
      <b-col
        cols="12"
        xl="12"
        lg="12"
        md="12"
      >
        <OffersViewInfoCardsVue :offer-entry="offerByID" />
      </b-col>
    </b-row>
    <b-row class="match-height mt-2">
      <b-col
        cols="12"
        xl="12"
        lg="12"
        md="12"
      >
        <OffersViewStoragesTable :offer-entry="offerByID" />
      </b-col>
    </b-row>
    <b-row class="match-height mt-2">
      <b-col
        cols="12"
        xl="12"
        lg="12"
        md="12"
      >
        <OffersViewZohoSignTable :offer-entry="offerByID" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from 'axios'
import { BRow, BCol } from 'bootstrap-vue'
import OffersViewInfoCardsVue from './OffersViewInfoCards.vue'
import OffersViewStoragesTable from './OffersViewStoragesTable.vue'
import OffersViewZohoSignTable from './OffersViewZohoSignTable.vue'
import OffersAction from './OffersViewActions.vue'

export default {
  components: {
    BRow,
    BCol,
    OffersViewInfoCardsVue,
    OffersViewStoragesTable,
    OffersViewZohoSignTable,
    OffersAction,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      statusPollingInterval: null,
    }
  },
  computed: {
    offerByID() {
      return this.$store.getters.offerByID(Number(this.id))
    },
  },
  mounted() {
    // Refresh order items to ensure we have the latest Zoho data
    console.log('OffersView mounted - refreshing order items')
    this.$store.dispatch('getOrderItemsEntries')

    // Load customers to enable mobile/country fallback for offers missing this data
    this.$store.dispatch('getCustomerEntries')

    // Start status polling for Zoho contracts
    this.startStatusPolling()
  },
  beforeDestroy() {
    // Clear polling when component is destroyed
    this.stopStatusPolling()
  },
  methods: {
    async checkZohoStatus() {
      try {
        console.log('Checking Zoho status for offer:', this.id)

        if (!this.offerByID?.id) {
          console.log('No offer ID available - skipping status checks')
          return
        }

        // Get ZohoContracts for this offer
        const zohoContracts = this.$store.getters['zohoContract/zohoContracts'] || []
        const offerContracts = zohoContracts.filter(contract => (contract.offer === this.offerByID.id || contract.offer?.id === this.offerByID.id)
          && contract.zohoDocumentId)

        console.log(`Found ${offerContracts.length} ZohoContracts for offer ${this.offerByID.id}`)

        // Process each contract sequentially to avoid await-in-loop
        const statusChecks = offerContracts
          .filter(contract => !['signed', 'declined', 'expired'].includes(contract.zohoSignStatus))
          .map(async contract => {
            try {
              console.log(`Checking status for document ${contract.zohoDocumentId}`)

              const response = await axios.get(
                `${process.env.VUE_APP_ZOHO_MIDDLEWARE_URL}/api/check-status/${contract.zohoDocumentId}`,
                {
                  timeout: 10000, // 10 second timeout
                }
              )

              if (response.data.success) {
                const newStatus = response.data.data.mappedStatus

                console.log(`Document ${contract.zohoDocumentId}: ${contract.zohoSignStatus} -> ${newStatus}`)

                // Update status if it has changed
                if (contract.zohoSignStatus !== newStatus) {
                  console.log(`Updating status for ZohoContract ${contract.id} from ${contract.zohoSignStatus} to ${newStatus}`)

                  // Update in ZohoContracts store
                  await this.$store.dispatch('zohoContract/updateZohoContract', {
                    id: contract.id,
                    zohoSignStatus: newStatus,
                  })

                  console.log(`Successfully updated ZohoContract ${contract.id} status to ${newStatus}`)
                }
              }
            } catch (error) {
              console.error(`Error checking status for document ${contract.zohoDocumentId}:`, error)
              // Continue with other documents even if one fails
            }
          })

        // Wait for all status checks to complete
        await Promise.allSettled(statusChecks)

        // Refresh ZohoContracts to ensure UI is updated
        await this.$store.dispatch('zohoContract/fetchZohoContracts')
      } catch (error) {
        console.error('Error in checkZohoStatus:', error)
      }
    },

    startStatusPolling() {
      // Check status immediately
      this.checkZohoStatus()

      // Then check every 30 seconds
      this.statusPollingInterval = setInterval(() => {
        this.checkZohoStatus()
      }, 30000) // 30 seconds

      console.log('Started Zoho status polling (every 30 seconds)')
    },

    stopStatusPolling() {
      if (this.statusPollingInterval) {
        clearInterval(this.statusPollingInterval)
        this.statusPollingInterval = null
        console.log('Stopped Zoho status polling')
      }
    },
  },
}
</script>
<style lang=""></style>
